<template>
  <div>
    <div class="right">
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for>道路:</label>
            <search-parking></search-parking>
          </div>
          <div class="form-group">
            <label for>地磁编号</label>
            <el-input v-model="search.devSn" placeholder="地磁编号"></el-input>
          </div>
          <div class="form-group">
            <label for>物联卡号</label>
            <el-input v-model="search.attr4" placeholder="物联卡号"></el-input>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </button>
            </span>
            <span class="add_btn">
              <button
                type="button"
                class="btn btn-default"
                id="addarea"
                @click="addOrEdit()"
              >
                添加
              </button>
            </span>
            <span class="operate-btn">
              <button
                type="button"
                class="btn btn-default"
                @click="executeBatchDel"
              >
                批量删除
              </button>
            </span>
            <span class="batchImport_btn">
              <button
                type="button"
                class="btn btn-default"
                @click="batchImport"
              >
                批量导入
              </button>
            </span>
            <span class="tableListDataAllNew_btn" style="margin-left: 4px">
              <button
                @click="downloadData"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                导出
              </button>
            </span>
          </div>
        </form>
      </div>
      <div class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData.rows"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
          @selection-change="checkedList"
        >
          <el-table-column
            show-overflow-tooltip
            type="selection"
            width="55"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="停车道路"
            prop="parkingName"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="地磁编号"
            prop="devSn"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="泊位号"
            prop="attr1"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="地磁类型"
            prop="company"
          ></el-table-column>
          <!-- <el-table-column
					label="生产商"
					prop="company"
				>
          </el-table-column>-->
          <el-table-column
            show-overflow-tooltip
            label="物联卡号"
            prop="attr4"
          ></el-table-column>
          <!-- <el-table-column
					label="泊位编号"
					prop="attr1"
				>
          </el-table-column>-->
          <!-- <el-table-column
					label="APP版本号"
					prop="appVersion"
				>
          </el-table-column>-->
          <el-table-column show-overflow-tooltip label="车位状态">
            <template slot-scope="scope">
              <span>{{ scope.row.hasCar == "1" ? "有车" : "无车" }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="强磁标志位">
            <template slot-scope="scope">
              <span>{{scope.row.magneticFlag=="1"?'有强磁干扰':'正常'}}</span>
            </template>
          </el-table-column>-->

          <!-- <el-table-column
					label="地磁电压"
					prop="cellVoltage"
				>
          </el-table-column>-->
          <!-- <el-table-column label="NB网络" prop="network"></el-table-column> -->
          <!-- <el-table-column label="心跳周期" prop="heartPeriod"></el-table-column> -->
          <el-table-column
            show-overflow-tooltip
            label="状态"
            prop="attr3"
          ></el-table-column>
          <el-table-column
          width='200'
            show-overflow-tooltip
            label="最后通讯时间"
            prop="lastUpTime"
          ></el-table-column>
          <el-table-column width='200' show-overflow-tooltip label="平台接受时间" prop="updTime"></el-table-column>
          <el-table-column show-overflow-tooltip label="电压/电量" prop="pow">
            <!-- <template slot-scope="scope">
              <div class="electricity">
                <div class="battery">
                  <canvas width="20" height="10" :id="scope.row.id" class="show_pow"></canvas>
                  <canvas width="5" height="5" :id="scope.row.id+'s'" class="pow_head"></canvas>
                </div>
                <div>{{!scope.row.pow?'':scope.row.pow}}</div>
              </div>
            </template> -->
          </el-table-column>
           <el-table-column label="信号值" prop="network"></el-table-column>
            <el-table-column label="信噪比" prop="snr"></el-table-column>
          <el-table-column label="流水号" prop="seq"></el-table-column>
           <el-table-column label="版本号" prop="attr5"></el-table-column>
          <el-table-column show-overflow-tooltip label="操作" width="200px">
            <template slot-scope="scope">
              <button
                class="edit"
                type="button"
                @click="addOrEdit(scope.row.id)"
              >
                修改
              </button>
              <button class="delete" @click="del(scope.row.id)" type="button">
                删除
              </button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- <Page :pageSize="search.pageSize" v-on:tableList='tableList'></Page>	 -->
    <Page v-on:pagination="receivePaginationData" v-bind:pageObj="pageObj"></Page>

    <!--添加/修改地磁-->
    <el-dialog
      :close-on-click-modal="false"
      ref="park"
      title="添加/修改地磁"
      :visible="dialogFormVisible"
      width="430px"
      :lock-scroll="false"
      @close="closeDialog"
    >
      <el-form
        ref="editOrAddForm"
        label-position="right"
        :model="editOrAddForm"
        :rules="editOrAddFormRules"
        :label-width="formLabelWidth"
      >
        <el-form-item label="生产商" prop="company" v-if="companyShow">
          <el-col :span="18">
            <el-select
              v-model.trim="editOrAddForm.company"
              placeholder="请选择"
            >
              <el-option
                v-for="item in producer"
                :key="item.value"
                :label="item.labelZhCh"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="停车道路" prop="parkingId">
          <el-col :span="18">
            <el-select
              filterable
              clearable
              v-model="editOrAddForm.parkingId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in parkingList"
                :key="item.parkingId"
                :label="item.parkingName"
                :value="item.parkingId"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="地磁类型" prop="company">
          <el-col :span="18">
            <el-select
              filterable
              clearable
              v-model="editOrAddForm.company"
              placeholder="请选择"
            >
              <el-option
                v-for="item in nbTypeList"
                :key="item.value"
                :label="item.labelDefault"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="地磁编号" prop="devSn">
          <el-col :span="18">
            <el-input v-model.trim="editOrAddForm.devSn"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="物联卡号">
          <el-col :span="18">
            <el-input v-model.trim="editOrAddForm.attr4"></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addOrEditTrue">确 定</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!--批量添加NB地磁-->
    <el-dialog
      :close-on-click-modal="false"
      title="批量添加地磁"
      :visible.sync="batchImportDialogFormVisible"
      width="500px"
      @closed="closeUpload"
    >
      <div class="downloadTemplate">
        <span class="downloadButtonText">
          <span class="tip">*</span>请先
          <span @click="bulkLoadTemplate" class="downloadButton">下载模板</span
          >，按照模板要求填入数据后，再上传文件
        </span>
      </div>
      <div class="upload">
        <el-upload
          ref="upload"
          class="upload-demo"
          action="/api/parking/nbOnerankdev/importExcelThread"
          :multiple="false"
          name="uploadFile"
          accept="MultipartFile"
          :limit="1"
          :auto-upload="false"
          :on-success="fileSuccess"
          :on-error="fileError"
        >
          <span>上传文件:</span>
          <el-button size="small" type="primary" class="uploadButton"
            >点击上传</el-button
          >
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitUpload" size="small"
          >确 定</el-button
        >
        <el-button @click="batchImportDialogFormVisible = false" size="small"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <!--批量添加NB地磁成功情况-->
    <el-dialog
      title="提示"
      :visible.sync="batchImportResultDialogFormVisible"
      width="500px"
    >
      <div ref="showBatchImportResult" class="showBatchImportResult"></div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import {
  batchDelNbGeomagnetism,
  nbList,
  editNb,
  greater50,
  correct,
  getAllStationList,
  allEquipStatus,
  delEquip,
  editEquip,
  getAllEquipList,
  getAllDatas,
  getAllParkingsByEnabled,
  addEquip,
  getOneEquip,
  getEquipList,
  getAllStatusList,
  getStatusList,
  dictValue,
  getOrderList,
  getZlNbOnerankdevList,
  upDateOneZlNbOnerankdev,
  tableListDataAll,
  fetchParkigList,
  requestNbType
} from "@/api/url";
import Page from "../../commons/page.vue";
import ExportExcel from "../../commons/exportExcel.vue";
import Refresh from "../../commons/refresh.vue";
import AreaTree from "../../commons/areaTree.vue";
import SearchParking from "@/page/commons/searchParking";
export default {
  name:'nb-geomagnetism',
  data() {
    return {
      dialogFormVisible: false,
      devManger_btn_edit: false,
      devManger_btn_remove: false,
      devManger_btn_add: false,
      batchImportResultDialogFormVisible: false,
      batchImportDialogFormVisible: false,
      cardShow: false,
      companyShow: true,

      moduleName: "",
      isChecked: true,
      park: "",

      styleObj: {
        "text-align": "center",
      },

      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      tableListParkDataAll: {},
      tableListAreaDataAll: {},
      allStations: {},
      parkingList: [],
      nbTypeList:[],
      editOrAddForm: {
        id: null,
        devSn: null,
        parkingId: null,
        uniqueAddress: null,
        company: null,
        attr4: null,
        type: null,
      },
      devStatus: [
        { name: "正常", value: "normal" },
        { name: "异常", value: "error" },
      ],
      editOrAddFormRules: {
        devSn: [{ required: true, message: "请填写地磁编号", trigger: "blur" }],
        parkingId: [
          {
            required: true,
            message: "请选择停车道路",
            trigger: ["blur", "change"],
          },
        ],
      },
      formLabelWidth: "100px",
      allOrderType: [],
      moduleName: "",
      temp: [],
      search: {
        pageNumber: 1,
        pageSize: 10,
        devStatu: "",
        devSn: "",
        attr4: "",
      },
      downloadFileds: {
        地磁编号: "onerankdevDevSn",
        网关编号: {
          field: "attr7",
          callback: (value) => {
            return value != "" && value != undefined
              ? JSON.parse(value).stationSn
              : "";
          },
        },
        泊位编号: {
          field: "attr8",
          callback: (value) => {
            return value != "" && value != undefined
              ? JSON.parse(value).spaceNum
              : "";
          },
        },
        停车道路: {
          field: "attr2",
          callback: (value) => {
            return value != "" && value != undefined
              ? JSON.parse(value).parkingName
              : "";
          },
        },
        泊位段: {
          field: "attr3",
          callback: (value) => {
            return value != "" && value != undefined
              ? JSON.parse(value).areaName
              : "";
          },
        },
        最后通讯时间: "lastFlowDate",
        地磁状态: "attr1",
        通信频率: "loraid",
      },
      producer: [
        {
          labelZhCh: "中联",
          value: "zhonglian",
        },
        {
          labelZhCh: "博斯凯",
          value: "bosk",
        },
      ],
      // areaAllType:[{
      // 	label:'地上',
      // 	value:'1'
      // },{
      // 	label:'地下',
      // 	value:'0'
      // }],
      tableListData: {
        rows: [],
      },
      tableListDataAll: {},
      pageObj:{}
    };
  },
  filters: {
    status(value) {
      var resultValue = "";
      switch (value) {
        case "error":
          resultValue = "异常";
          break;
        case "异常":
          resultValue = "异常";
          break;
        case "normal":
          resultValue = "正常";
          break;
        case "正常":
          resultValue = "正常";
          break;
        default:
          break;
      }
      return resultValue;
    },
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },

    tableList: function (curPage) {
      var _this = this;
      //合并NB地磁借口
      const { devSn, attr4, pageSize } = this.search;
      this.$get(nbList(), {
        devSn: devSn ? devSn : null,
        attr4: attr4 ? attr4 : null,
        // spaceNum:'',
        parkingId: this.parking?.parkingId ?? null,
        limit: pageSize,
        page: curPage,
      }).then((data) => {
        if (data.status != 200) return;
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        // _this.getPage(pageObj);
        _this.pageObj={...pageObj}
        const {
          data: { rows },
        } = data;
        _this.tableListData.rows = rows.map((item) => {
          if (
            item.parkingId &&
            typeof JSON.parse(item.parkingId) === "object"
          ) {
            item.parkingName = JSON.parse(item.parkingId).parkingName;
          }
          if(item.attr5==="null")item.attr5=""
          return item;
        });
        _this.$nextTick(this.canvasPow);
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      });
    },
    // canvasPow() {
    //   var _this = this;
    //   for (let item of _this.tableListData.rows) {
    //     var canvas = document.getElementById(item.id);
    //     canvas.style = "border:1px solid #696969";
    //     var context = canvas.getContext("2d");
    //     context.clearRect(0, 0, 20, 10);
    //     if (item.pow >= 0) {
    //       // if (item.pow >= 80) {
    //       context.fillStyle = "green";
    //       // } else if (item.pow >= 40 && item.pow < 80) {
    //       //   context.fillStyle = "#FF6100";
    //       // } else if (item.pow < 40) {
    //       //   context.fillStyle = "red";
    //       // }
    //       context.fillRect(0, 0, 20, 10);
    //     }
    //     // context.fillRect(0, 0, (20 / 100) * item.pow, 10);
    //     var canvas1 = document.getElementById(item.id + "s");
    //     var context1 = canvas1.getContext("2d");
    //     context1.fillStyle = "#696969";
    //     context1.fillRect(0, 0, 5, 5);
    //   }
    // },
    tableListAll: function () {
      var _this = this;
      this.$get(getAllEquipList()).then((data) => {
        //if(data.status!=200) return _this.$layer.msg(data.message);
        this.tableListDataAll = data.data;
      });
    },
    tableListParkAll: function () {
      this.$get(getAllParkingsByEnabled()).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        var rows = data.data.rows;
        for (var i in rows) {
        }
        //console.log("tableListDataAll")
        //console.log(this.tableListData.rows)
        this.tableListParkDataAll = data.data;
      });
    },

    async addOrEdit(id) {
      this.dialogFormVisible = true;
      // this.editOrAddForm.company = "bosk";
      this.companyShow = false;
      await this.getParkingList();
      await this.getNbTypeList();
      if (!id) {
        this.editOrAddForm = {
          parkingId: null,
          devSn: null,
          attr4: null,
          company: "",
        };

        // if (!this.treeData.parkingId) {
        //   this.$message({
        //     type: "warning",
        //     message: "请选择道路",
        //   });
        //   this.dialogFormVisible = false;
        //   this.companyShow = true;
        //   this.cardShow = false;
        //   return;
        // }
      } else {
        this.$get(editNb() + "/" + id).then((data) => {
          if (data.status != 200) return;
          // this.companyShow = false;
          const {
            data: { devSn, attr4, attr2, company, id, parkingId },
          } = data;
          this.editOrAddForm = {
            id,
            devSn,
            attr4,
            attr2,
            parkingId,
            company
          };

          // if (company === "zhonglian") {
          //   this.cardShow = false;
          // } else {
          //   this.cardShow = true;
          // }
        });
      }
    },
    addOrEditTrue() {
      var _this = this;
      this.$refs.editOrAddForm.validate(function (valid, noStri) {
        if (valid) {
          _this.dialogFormVisible = false;
          if (!_this.editOrAddForm.id) {
            _this
              .$postRequest(editNb(), {
                devSn: _this.editOrAddForm.devSn,
                parkingId: _this.editOrAddForm.parkingId,
                attr4: _this.editOrAddForm.attr4,
                company:_this.editOrAddForm.company,
                // company: "bosk",
              })
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);
                if (data.status == 200) {
                  _this.$notify({
                    type: "success",
                    message: "添加成功！",
                    title: "成功",
                  });
                  _this.search.pageNumber = 1;
                  _this.tableList(_this.search.pageNumber);
                }
              });
          } else {
            _this
              .$putRequest(editNb() + "/" + _this.editOrAddForm.id, {
                devSn: _this.editOrAddForm.devSn,
                id: _this.editOrAddForm.id,
                parkingId: _this.editOrAddForm.parkingId,
                attr4: _this.editOrAddForm.attr4,
                company:_this.editOrAddForm.company,
              })
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);

                _this.$notify({
                  type: "success",
                  message: "修改成功！",
                  title: "成功",
                });
                _this.tableList(_this.pageObj.curIndex);
              });
          }
        }
      });
    },
    closeDialog: function () {
      this.$refs.editOrAddForm.resetFields();
    },
    del: function (id) {
      var _this = this;
      // console.log(id)
      var index = _this.$layer.confirm(
        "您确定删除该设备吗？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);
          // console.log("222")
          _this.$deleteRequest(editNb() + "/" + id, {}).then((data) => {
            if (data.status == 200) {
              _this.$notify({
                type: "success",
                message: "删除成功！",
                title: "成功",
              });
              _this.tableList(_this.pageObj.curIndex);
            }
            if (data.status == 30101) {
              _this.$notify.error({
                message:
                  "设备已绑定车位信息，不允许删除！如需删除，请先解绑设备和车位！",
                title: "失败",
              });
            }
          });
        }
      );
    },
    searchList: function () {
      // var flTime=this.timeCompare(this.search.startTime,this.search.endTime);
      // // console.log(this.search.endTime)
      // if(flTime){
      // 	return this.$layer.msg('开始时间请勿大于结束时间', { time: 1});
      // }else if(!Boolean(this.search.startTime)&&Boolean(this.search.endTime)){
      // 	return this.$layer.msg('请选择开始时间', { time: 1});
      // }else if(Boolean(this.search.startTime)&&!Boolean(this.search.endTime)){
      // 	return this.$layer.msg('请选择结束时间', { time: 1});
      // }

      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    // timeCompare:function(bDateVal,eDateVal){
    // 	// console.log(bDateVal,eDateVal);

    // 	if(!Boolean(bDateVal)||!Boolean(eDateVal)){
    // 		return false;
    // 	}

    // 	var bdate = new Date(Date.parse(bDateVal.replace(/-/g, "/")));
    // 	bdate = bdate.getTime();
    // 	var edate = new Date(Date.parse(eDateVal.replace(/-/g, "/")));
    // 	edate = edate.getTime();
    // 	if(bdate-edate>0){
    // 		return true;
    // 	}else{
    // 		return false;
    // 	}
    // },

    //  导出数据
    // tableListDataAllNew(){
    // 			window.open(`api/parking/nbOnerankdev/ExportNbOnerankdev?parkingId=${this.treeData.parkingId}`, '_self');
    // 		},

   downloadData(){
     const { devSn, attr4 } = this.search;
      this.$downloadFileRequest(
        "/api/parking/nbOnerankdev/exportNbOnerankdev",
        {
         devSn: devSn ? devSn : null,
        attr4: attr4 ? attr4 : null,
        parkingId: this.parking?.parkingId ?? null,
        },
        "nb地磁"
      );
   },

    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.type = "";
      this.search.startTime = "";
      this.search.endTime = "";
      this.search.devNum = "";
    },
    //  导出数据

    batchImport() {
      this.batchImportDialogFormVisible = true;
      // this.$refs.upload.clearFiles();
    },
    //批量上传
    submitUpload() {
      this.batchImportDialogFormVisible = false;
      // this.treeData.parkingId='';
      // this.treeData.areaId='';
      // this.$refs.areaTree.setCurrent('001');
      this.$refs.upload.submit();
      // this.search.pageNumber=1;
      // this.tableList(this.search.pageNumber);
    },
    bulkLoadTemplate() {
      window.open("api/parking/nbOnerankdev/importTemplate/", "_self");
    },
    fileSuccess(response, file, fileList) {
      var _this = this;
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
      this.batchImportResultDialogFormVisible = true;
      let span = document.createElement("span");
      this.$nextTick(function () {
        _this.$refs.showBatchImportResult.innerHTML = "";
        span.innerHTML = response.data;
        _this.$refs.showBatchImportResult.appendChild(span);
      });
    },
    fileError(err, file, fileList) {
      // console.log(err)
    },
    closeUpload() {
      this.$refs.upload.clearFiles();
    },
    checkedList(val) {
      this.batchDel = val.map((item) => {
        return item.id;
      });
    },
    executeBatchDel() {
      this.$postRequest(batchDelNbGeomagnetism(), {
        ids: this.batchDel,
      }).then((data) => {
        if (data.status == 200) {
          this.$notify({
            type: "success",
            message: "批量删除成功！",
            title: "成功",
          });
          this.tableList(this.pageObj.curIndex);
          this.batchDel = [];
          // if (this.$refs.checkBoxAll.checked) {
          //   this.$refs.checkBoxAll.checked = false;
          // }
        }
      });
    },
    getParkingList() {
      return this.$get(fetchParkigList()).then((res) => {
        const { status, data } = res;
        if (status === 200) {
          this.parkingList = data;
        }
      });
    },
    getNbTypeList(){
       return this.$get(requestNbType()).then((res) => {
        const { status, data:{rows}} = res;
        if (status === 200) {
          this.nbTypeList = rows;
        }
      });
    }
  },

  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
      parking: (state) => state.parking.oneParking,
    }),
    ...mapGetters(["elements"]),
    permiss() {
      this.devManger_btn_edit = this.elements["devManger:btn_edit"];
      this.devManger_btn_remove = this.elements["devManger:btn_remove"];
      this.devManger_btn_add = this.elements["devManger:btn_add"];
    },
  },

  components: {
    Page,
    // StationTree,
    ExportExcel,
    Refresh,
    AreaTree,
    SearchParking,
  },
  created: function () {
    //this.getOrderType();
  },
  mounted: function () {
    this.permiss;
    this.tableList(this.search.pageNumber);
    // this.tableListAll();
    // this.tableListParkAll();
  },
  watch: {
    elements: {
      handler: function (val, oldVal) {
        this.permiss;
      },
      deep: true, //深度
    },
    // 'editOrAddForm.parkingId'(val){

    // 	  	this.tableListAreaAll(val);
    //   }
  },
};
</script>

<style scoped>
/* @import "@/assets/css/equip.css"; */
.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}

.btns {
  margin: 20px auto 0;
  width: 150px;
}

table td label {
  margin-bottom: 0 !important;
}
.show_pow {
  border: 1px solid #696969;
  border-radius: 2px;
}
.pow_head {
  border-radius: 1px;
}
.boxbgcolor {
  display: flex;
}
.battery {
  width: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}
.electricity {
  display: flex;
  justify-content: center;
  align-items: center;
}
.downloadButton {
  font-weight: bold;
  color: #278cd8;
  cursor: pointer;
}
.list {
  padding: 0 !important;
}
.table thead {
  background: #f9f9fb;
}
.searchbox .el-input {
  width: 180px !important;
}
</style>
